<div class="weather-middle">
  <div class="weather-middle__tabs">
    <button
      class="weather-middle__tab"
      [class.weather-middle__tab--active]="store.selectedTab() === 'temperature'"
      (click)="selectTab('temperature')"
    >
      {{ 'FLEX_HOME.WEATHER_WIDGET.TEMPERATURE' | translate }}
    </button>
    <!-- TODO: Uncomment when API is ready -->
    <!-- <button class="weather-middle__tab" [class.weather-middle__tab--active]="store.selectedTab() === 'precipitation'" (click)="selectTab('precipitation')">{{ 'FLEX_HOME.WEATHER_WIDGET.PRECIPITATION' | translate }}</button>
    
    <button class="weather-middle__tab" [class.weather-middle__tab--active]="store.selectedTab() === 'wind'" (click)="selectTab('wind')">{{ 'FLEX_HOME.WEATHER_WIDGET.WIND' | translate }}</button> -->
  </div>
  <div class="weather-middle__separator"></div>

  <div class="weather-middle__unit-toggle" role="group" aria-label="Temperature unit">
    <button
      class="weather-middle__unit-toggle-btn"
      [class.weather-middle__unit-toggle-btn--active]="store.unit() === TempUnit.C"
      (click)="toggleUnit(TempUnit.C)"
    >
      °C
    </button>
    <button
      class="weather-middle__unit-toggle-btn"
      [class.weather-middle__unit-toggle-btn--active]="store.unit() === TempUnit.F"
      (click)="toggleUnit(TempUnit.F)"
    >
      °F
    </button>
  </div>
</div>

<div #wrap class="chart-wrap">
  <canvas #chartCanvas class="weather-middle__chart"></canvas>
</div>
